import {client} from '@core/GraphQLProvider';
import {GetTaxonomy} from './query.graphql';

const SiteMapService = {
    async getTaxonomy () {
        const resp = await client.query( {
            query: GetTaxonomy,
            context: {timeout: 30000}
        } );

        return resp.data.taxonomy;
    }
};

export default SiteMapService;
